export default __webpack_public_path__ + "static/media/island.ead06238.webp";